import { ChatInstance } from '../internal/chat-instance/chat-instance';
import { getProvider } from '../internal/get-provider/get-provider';
import { restRequest } from '../internal/rest/rest';
import { UserInfo } from '../internal/user-info/user-info';
import { StatusTypes } from './models/events-models';
export class EnGenChat {
  constructor(config) {
    this.session = {
      chatInstance: new ChatInstance(),
      userInfo: new UserInfo(),
      config,
    };
    this.onChatStart =
      this.session.chatInstance.observableEvents().onChatStart$;
    this.onChatEnd = this.session.chatInstance.observableEvents().onChatEnd$;
    this.onStatusChange =
      this.session.chatInstance.observableEvents().onStatusChange$;
    this.onTransferRequest =
      this.session.chatInstance.observableEvents().onTransferRequest$;
    this.onParticipantJoin =
      this.session.chatInstance.observableEvents().onParticipantJoin$;
    this.onParticipantLeave =
      this.session.chatInstance.observableEvents().onParticipantLeave$;
    this.onIsTyping = this.session.chatInstance.observableEvents().onIsTyping$;
    this.onNewMessage =
      this.session.chatInstance.observableEvents().onNewMessage$;
    this.onMessageAcknowledgement =
      this.session.chatInstance.observableEvents().onMessageAcknowledgement$;
    this.onError = this.session.chatInstance.observableEvents().onError$;
    this.transferProviders();
  }
  startChat(token, providerId, newChatRequest) {
    if (this.session.chatInstance.getCurrentChatState() !== StatusTypes.READY) {
      this.session.chatInstance.emitError(
        'START_CHAT_NOT_READY',
        'Not in a ready state.',
      );
      return;
    }
    this.chatProvider = new (getProvider(providerId))(this.session);
    this.chatProvider
      .checkAvailability(token, providerId, newChatRequest)
      .then((availResult) => {
        if (availResult.isAvailable) {
          this.chatProvider.startChat(token);
        } else {
          this.session.chatInstance.emitError(
            'PROVIDER_UNAVAILABLE',
            availResult.unavailableReason,
            true,
          );
          this.session.chatInstance.emitStatusChange(
            this.chatProvider.providerIdentifier,
            StatusTypes.UNAVAILABLE,
          );
        }
      });
  }
  closeChat() {
    const state = this.session.chatInstance.getCurrentChatState();
    if (
      state === StatusTypes.CONNECTING ||
      state === StatusTypes.QUEUED ||
      state === StatusTypes.CONNECTED ||
      state === StatusTypes.RECONNECTING
    ) {
      this.chatProvider.closeChat();
      this.session.chatInstance.emitChatEnd('CLIENT');
    } else {
      this.session.chatInstance.emitError(
        'CLOSE_CHAT_FAILURE',
        'Not in a connected state.',
      );
    }
  }
  sendMessage(token, text) {
    const state = this.session.chatInstance.getCurrentChatState();
    if (state === StatusTypes.QUEUED || state === StatusTypes.CONNECTED) {
      return this.chatProvider.sendMessage(token, text);
    } else {
      this.session.chatInstance.emitError(
        'MESSAGE_SEND_FAILURE',
        'Not in connected state',
      );
    }
  }
  sendEvent(token, event) {
    const state = this.session.chatInstance.getCurrentChatState();
    if (state === StatusTypes.QUEUED || state === StatusTypes.CONNECTED) {
      return this.chatProvider.sendEvent(token, event);
    } else {
      this.session.chatInstance.emitError(
        'EVENT_SEND_FAILURE',
        'Not in connected state',
      );
    }
  }
  sendIsTyping() {
    const state = this.session.chatInstance.getCurrentChatState();
    if (state === StatusTypes.QUEUED || state === StatusTypes.CONNECTED) {
      this.chatProvider.sendIsTyping();
    } else {
      this.session.chatInstance.emitError(
        'MESSAGE_SEND_FAILURE',
        'Not in connected state',
      );
    }
  }
  async checkAvailability(token) {
    const state = this.session.chatInstance.getCurrentChatState();
    const invalidStates = [
      StatusTypes.ERROR,
      StatusTypes.CONNECTED,
      StatusTypes.CONNECTING,
      StatusTypes.RECONNECTING,
      StatusTypes.QUEUED,
    ];
    if (invalidStates.includes(state)) {
      throw Error('CHECK_AVAILABILITY_ERROR');
    }
    try {
      const providers = await restRequest(
        `https://${this.session.config.environment}/digital/v2/chat/api/availability?version=${this.session.config.version}`,
        'GET',
        undefined,
        token,
      );
      if (providers.some((provider) => provider.isAvailable)) {
        this.session.chatInstance.emitStatusChange(
          {
            providerId: '',
            providerName: '',
          },
          StatusTypes.READY,
        );
      } else {
        this.session.chatInstance.emitStatusChange(
          {
            providerId: '',
            providerName: '',
          },
          StatusTypes.UNAVAILABLE,
        );
      }
      return providers;
    } catch (e) {
      throw Error('CHECK_AVAILABILITY_ERROR');
    }
  }
  transferProviders() {
    this.session.chatInstance
      .getProviderTransferEvent()
      .subscribe(async (transferData) => {
        const newProvider = new (getProvider(
          transferData.transferToProviderId,
        ))(this.session);
        const availResult = await newProvider.checkAvailability(
          transferData.access_token,
          transferData.transferToProviderId,
          Object.assign(
            { sessionId: transferData.sessionId },
            transferData.requestData,
          ),
        );
        if (
          this.session.chatInstance.getCurrentChatState() !==
          StatusTypes.CONNECTED
        ) {
          this.session.chatInstance.transferCanceled();
          return;
        } else if (!availResult.isAvailable) {
          this.chatProvider.onTransferResult(
            transferData.transferToProviderId,
            false,
          );
          return;
        }
        this.chatProvider.onTransferResult(
          transferData.transferToProviderId,
          true,
        );
        this.chatProvider.closeChat();
        this.chatProvider = newProvider;
        this.chatProvider.startChat(transferData.access_token);
      });
  }
}
//# sourceMappingURL=chat.js.map
